import type { ComparisonRow, CostRow } from '../types/content'

export const sistemaTotalRows: ComparisonRow[] = [
  {
    situation: 'Querés crear un hábito sostenible',
    without: 'Empezás bien y a la semana volvés a lo de siempre',
    with: 'Protocolo de 30 días que construye el hábito paso a paso',
  },
  {
    situation: 'No sabés si tomás suficiente agua',
    without: 'Improvisás y olvidás hidratarte',
    with: 'Plan de hidratación semanal integrado al sistema',
  },
  {
    situation: 'Querés saber qué suplementos valen la pena',
    without: 'Comprás cosas caras que quizás no necesitás',
    with: 'Guía clara de suplementación básica accesible en Argentina',
  },
  {
    situation: 'Querés entender el por qué del cambio',
    without: 'Solo tenés recetas sin contexto',
    with: 'Manual completo que conecta cocina, hábitos y bienestar real',
  },
]

export const costRows: CostRow[] = [
  {
    situation: '3 hs improvisando comida × 50 semanas',
    cost: '150 horas de tu vida por año',
  },
  {
    situation: 'Delivery 3 veces por semana',
    cost: '$500.000+ ARS al AÑO perdidos',
  },
  {
    situation: 'Heladera desorganizada',
    cost: '30-40% de la comida se tira',
  },
  {
    situation: 'Sin vianda al trabajo',
    cost: '$15.000 por día en comida afuera',
  },
  {
    situation: 'Sin sistema de hábitos',
    cost: 'El mismo ciclo el próximo año',
  },
  {
    situation: 'Domingo buscando recetas en internet',
    cost: 'Estrés acumulado semana tras semana',
  },
]
